window.location.replace('https://scene.yayya.live/app/docs/privacy-policy-android');

export default function PrivacyPolicy() {
  return null;
}



// WEBPACK FOOTER //
// src/pages/app/privacypolicy/index.js